import React, { useEffect } from 'react';

const PickerModal = ({ 
  showPicker, 
  pickerSearch, 
  setPickerSearch, 
  getFilteredOptions, 
  getSelectedIndexInFiltered, 
  pickerField,
  pickerValue,
  selectPickerValue,
  closePicker,
  addPriznakToItem,
  removePriznakFromItem,
  activeModalItemId
}) => {
  // Закрытие окна выбора по Escape
  useEffect(() => {
    if (!showPicker) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        closePicker();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [showPicker, closePicker]);

  if (!showPicker) return null;

  const isCausePicker = pickerField === 'prichina';

  return (
    <div className="picker-overlay" onClick={closePicker}>
      <div
        className="picker-modal"
        onClick={(e) => e.stopPropagation()}
        style={isCausePicker ? { width: '95vw', maxWidth: '1400px' } : undefined}
      >
        <div className="picker-header">
          <h3>Выберите значение</h3>
          <button className="picker-close" onClick={closePicker}>×</button>
        </div>
        <div className="picker-search">
          <input
            type="text"
            placeholder="Поиск..."
            value={pickerSearch}
            onChange={(e) => setPickerSearch(e.target.value)}
            className="picker-search-input"
            autoFocus
          />
          {pickerSearch && (
            <button
              className="picker-search-clear"
              onClick={() => setPickerSearch('')}
              title="Очистить поиск"
            >
              ✕
            </button>
          )}
        </div>
        <div className="picker-content">
          {getFilteredOptions().length > 0 ? (
            <>
              {pickerField === 'prizn' ? (
                // Множественный выбор для признаков с чекбоксами в виде таблицы
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <tbody>
                    {getFilteredOptions().map((option, index) => {
                      const selectedValues = Array.isArray(pickerValue) ? pickerValue : [];
                      const isSelected = selectedValues.includes(option.value);
                      const isHighlighted = index === getSelectedIndexInFiltered();
                      return (
                        <tr
                          key={option.value}
                          onClick={(e) => {
                            if (e.target.type !== 'checkbox') {
                              const checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
                              if (checkbox) {
                                checkbox.click();
                              }
                            }
                          }}
                          className={`${isSelected ? 'selected' : ''} ${isHighlighted ? 'highlighted' : ''}`}
                          style={{
                            backgroundColor: isHighlighted ? '#e3f2fd' : 'transparent',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s'
                          }}
                        >
                          <td style={{ 
                            width: '40px', 
                            padding: '12px 8px',
                            textAlign: 'center',
                            verticalAlign: 'middle'
                          }}>
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={(e) => {
                                e.stopPropagation();
                                if (e.target.checked) {
                                  if (addPriznakToItem && activeModalItemId) {
                                    addPriznakToItem(activeModalItemId, option.value);
                                  }
                                } else {
                                  if (removePriznakFromItem && activeModalItemId) {
                                    removePriznakFromItem(activeModalItemId, option.value);
                                  }
                                }
                              }}
                              onClick={(e) => e.stopPropagation()}
                              style={{ 
                                cursor: 'pointer',
                                outline: 'none',
                                boxShadow: 'none',
                                margin: '0 auto',
                                display: 'block'
                              }}
                              onFocus={(e) => e.target.style.outline = 'none'}
                            />
                          </td>
                          <td style={{ 
                            padding: '12px 16px',
                            verticalAlign: 'middle'
                          }}>
                            <div style={{ fontWeight: '500' }}>{option.label}</div>
                            {option.description && (
                              <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                                {option.description}
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                // Обычный выбор для других полей
                <ul className="picker-list">
                  {getFilteredOptions().map((option, index) => {
                    const isSelected = pickerValue === option.value;
                    const isHighlighted = index === getSelectedIndexInFiltered();
                    return (
                      <li 
                        key={option.value} 
                        onClick={() => selectPickerValue(option.value)}
                        className={`${isSelected ? 'selected' : ''} ${isHighlighted ? 'highlighted' : ''}`}
                        style={{
                          backgroundColor: isHighlighted ? '#e3f2fd' : 'transparent'
                        }}
                      >
                        <div style={{ fontWeight: '500' }}>{option.label}</div>
                        {option.description && (
                          <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                            {option.description}
                          </div>
                        )}
                      </li>
                    );
                  })}
                </ul>
              )}
              {pickerField === 'prizn' && (
                <div style={{ 
                  padding: '10px', 
                  borderTop: '1px solid #eee',
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}>
                  <button
                    onClick={closePicker}
                    style={{
                      padding: '6px 16px',
                      backgroundColor: '#6c757d',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '14px'
                    }}
                  >
                    Готово
                  </button>
                </div>
              )}
            </>
          ) : (
            <div className="picker-no-results">
              <p>Ничего не найдено</p>
              <p style={{ fontSize: '12px', color: '#666' }}>
                Попробуйте изменить поисковый запрос
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PickerModal;

